import Swiper from "./swiper-bundle.esm.browser.min.js";

document.addEventListener("DOMContentLoaded", function () {
 
  // =========== Start: Performance Review Slider ============= //
  function initPerformanceReviewSlider() {
    const sliders = document.querySelectorAll("[data-review-slider]");

    if (!sliders.length) return;

    sliders.forEach((slider) => {
      if (slider.swiper) return;

      const slideCount = slider.querySelectorAll(".swiper-slide").length;
      const paginationEl = slider.querySelector(
        ".performance-review__pagination"
      );
      new Swiper(slider, {
        slidesPerView: 1,
        spaceBetween: 12,
        loop: slideCount > 1,
        pagination:
          slideCount > 1 && paginationEl
            ? {
                el: paginationEl,
                clickable: true,
              }
            : false,
      });
    });
  }
  // =========== End: Performance Review Slider ============= //

  // =========== Start: Benefits Slider ============= //
  function initBenefitsSlider() {
    const sliders = document.querySelectorAll("[data-benefits-slider]");

    if (!sliders.length) return;

    sliders.forEach((slider) => {
      if (slider.swiper) return;

      const slideCount = slider.querySelectorAll(".swiper-slide").length;
      const isBenefitsV2 = slider.closest(".lp-benefits-v2");

      const desktopSlides = isBenefitsV2 ? 5 : 4;
      const mobileSlides = isBenefitsV2 ? 2 : 1.13;
      const spaceBetween = isBenefitsV2 ? 0 : 20;

      new Swiper(slider, {
        slidesPerView: 4,
        spaceBetween: spaceBetween,
        loop: slideCount > desktopSlides,

        breakpoints: {
          0: {
            slidesPerView: mobileSlides,
          },
          544: {
            slidesPerView: 2,
          },
          768: {
            slidesPerView: 3,
          },
          992: {
            slidesPerView: desktopSlides,
          },
        },
      });
    });
  }


  // =========== End: Benefits Slider ============= //

  // =========== Start: LP Reviews Slider ============= //
  document.querySelectorAll('.review-slider').forEach(function (slider) {
    if (slider.swiper) return;

    new Swiper(slider, {
      slidesPerView: 3,
      spaceBetween: 10,
      speed: 500,
      watchOverflow: true,
      pagination: {
        el: slider.querySelector('.review-slider-pagination'),
        clickable: true,
      },
      breakpoints: {
        0: {
          slidesPerView: 1.232,
          spaceBetween: 10,
        },
        750: {
          slidesPerView: 2,
          spaceBetween: 10,
        },
        990: {
          slidesPerView: 3,
          spaceBetween: 16,
        },
      },
    });
  });
  // =========== End: LP Reviews Slider ============= // 

  // =========== START: Size Modal ============= // 
  document.addEventListener('click', function (event) {
    const openButton = event.target.closest('.wt-product__option__modal');

    if (!openButton) {
      return;
    }

    event.preventDefault();

    const modalId = openButton.getAttribute('aria-controls');

    if (!modalId) {
      console.warn('Quiz opener is missing aria-controls:', openButton);
      return;
    }

    const modal = document.getElementById(modalId);

    if (!modal) {
      console.warn('Quiz modal not found:', modalId);
      return;
    }

    resetQuiz(modal);

    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');

    document.body.classList.add('wt-quiz-open');
  });
  const quizModals = document.querySelectorAll('[data-wt-quiz]');
    quizModals.forEach(function (modal) {
      const closeButtons = modal.querySelectorAll('[data-quiz-close]');
      const overlay = modal.querySelector('.wt-quiz-modal__overlay');
      const steps = modal.querySelectorAll('[data-quiz-step]');
      const answers = modal.querySelectorAll('.wt-quiz-answer');
      const backButton = modal.querySelector('[data-quiz-back]');
      const result = modal.querySelector('[data-quiz-result]');
      const resultImage = modal.querySelector('[data-result-image]');
      const resultTitle = modal.querySelector('[data-result-title]');
      let quizAnswers = {
        q1: null,
        q2: null
      };
      closeButtons.forEach(function (button) {
        button.addEventListener('click', function (event) {
          event.preventDefault();
          event.stopPropagation();

          closeQuiz();
        });
      });
      if (overlay) {
        overlay.addEventListener('click', function (event) {
          event.preventDefault();
          event.stopPropagation();
          if (event.target === overlay) {
            closeQuiz();
          }
        });
      }
      answers.forEach(function (button) {
        button.addEventListener('click', function (event) {
          event.preventDefault();

          const question = button.dataset.question;
          const answer = button.dataset.answer;
          const sameQuestion = modal.querySelectorAll(
            '[data-question="' + question + '"]'
          );

          sameQuestion.forEach(function (item) {
            item.classList.remove('is-selected');
          });
          button.classList.add('is-selected');
          if (question === '1') {
            quizAnswers.q1 = answer;

            setTimeout(function () {
              showStep(2);
            }, 200);
          }
          if (question === '2') {
            quizAnswers.q2 = answer;

            setTimeout(function () {
              showResult();
            }, 200);
          }
        });
      });
      if (backButton) {
        backButton.addEventListener('click', function (event) {
          event.preventDefault();

          showStep(1);
        });
      }
      function showStep(stepNumber) {
    steps.forEach(function (step) {
      step.classList.remove('is-active');
    });
    const targetStep = modal.querySelector(
      '[data-quiz-step="' + stepNumber + '"]'
    );
    if (targetStep) {
      targetStep.classList.add('is-active');
    }
    if (result) {
      result.classList.remove('is-active');
    }
    modal.classList.remove('active-result');
  }
  function showResult() {
    steps.forEach(function (step) {
      step.classList.remove('is-active');
    });

    const combination =
      quizAnswers.q1 + '_' + quizAnswers.q2;

    const resultData = modal.querySelector(
      '[data-result="' + combination + '"]'
    );

    if (!resultData) {
      return;
    }

    const image = resultData.dataset.image || '';
    const title = resultData.dataset.title || '';

    if (resultImage) {
      resultImage.src = image;
      resultImage.alt = title;
    }

    if (resultTitle) {
      resultTitle.innerHTML = title;
    }

    if (result) {
      result.classList.add('is-active');
      modal.classList.add('active-result');
    }
  }
  function closeQuiz() {
    console.log('Closing quiz:', modal.id);
    modal.classList.remove('is-open');
    modal.classList.remove('active-result');

    modal.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('wt-quiz-open');
    resetQuiz();
  }
  function resetCurrentQuiz() {
    quizAnswers = {
      q1: null,
      q2: null
    };
    steps.forEach(function (step) {
      step.classList.remove('is-active');
    });

    const firstStep = modal.querySelector(
      '[data-quiz-step="1"]'
    );

    if (firstStep) {
      firstStep.classList.add('is-active');
    }

    if (result) {
      result.classList.remove('is-active');
    }
    answers.forEach(function (answer) {
      answer.classList.remove('is-selected');
    });
    if (resultImage) {
      resultImage.src = '';
      resultImage.alt = '';
    }
    if (resultTitle) {
      resultTitle.textContent = '';
    }
  }
  document.addEventListener('keydown', function (event) {
    if (
      event.key === 'Escape' &&
      modal.classList.contains('is-open')
    ) {
      closeQuiz();
    }
  });
    modal.resetQuiz = resetCurrentQuiz;
  });
  function resetQuiz(modal) {
    if (typeof modal.resetQuiz === 'function') {
      modal.resetQuiz();
    }
  }
  // =========== END: Size Modal ============= //

  // =========== Start: FAQ JS ============= //
  (function () {
    function initFaqAccordion(section) {
      var accordion = section.querySelector('[data-faq-accordion]');
      if (!accordion || accordion.dataset.initialized === 'true') return;
      accordion.dataset.initialized = 'true';
      var items = accordion.querySelectorAll('.faq-accordion-item');
      function openItem(item) {
        var answer = item.querySelector('.faq-accordion-answer');
        var button = item.querySelector('.faq-accordion-question');
        if (!answer || !button) return;
        items.forEach(function (otherItem) {
          if (otherItem !== item) {
            closeItem(otherItem);
          }
        });
        item.classList.add('is-open');
        button.setAttribute('aria-expanded', 'true');
        answer.style.maxHeight = answer.scrollHeight + 'px';
      }
      function closeItem(item) {
        var answer = item.querySelector('.faq-accordion-answer');
        var button = item.querySelector('.faq-accordion-question');
        if (!answer || !button) return;
        item.classList.remove('is-open');
        button.setAttribute('aria-expanded', 'false');
        answer.style.maxHeight = '0px';
      }
      items.forEach(function (item) {
        item.addEventListener('click', function (event) {
          if (event.target.closest('a')) return;
          var isOpen = item.classList.contains('is-open');
          if (isOpen) {
            closeItem(item);
          } else {
            openItem(item);
          }
        });
      });
      items.forEach(function (item) {
        if (item.classList.contains('is-open')) {
          openItem(item);
        }
      });
      window.addEventListener('resize', function () {
        var openItemElement = accordion.querySelector('.faq-accordion-item.is-open');
        if (openItemElement) {
          var answer = openItemElement.querySelector('.faq-accordion-answer');
          if (answer) {
            answer.style.maxHeight = answer.scrollHeight + 'px';
          }
        }
      });
    }
    document.querySelectorAll('.faq-accordion-section').forEach(function (section) {
      initFaqAccordion(section);
    });
    document.addEventListener('shopify:section:load', function (event) {
      var section = event.target.closest('.faq-accordion-section');
      if (section) {
        initFaqAccordion(section);
      }
    });
  })();
  // =========== End: FAQ JS ============= //

  // =========== Start: Formula Benefits Slider ============= //
  // document.querySelectorAll(".formula-benefits-section").forEach(function (section) {
  //   var slider = section.querySelector(".formula-benefits-swiper");
  //   if (!slider || slider.swiper || typeof Swiper === "undefined") return;
  //   var swiper = new Swiper(slider, {
  //     slidesPerView: 4,
  //     spaceBetween: 16,
  //     speed: 500,
  //     watchOverflow: true,
  //     pagination: {
  //       el: section.querySelector(".formula-benefits-section__pagination"),
  //       clickable: true
  //     },
  //     breakpoints: {
  //       0: {
  //         slidesPerView: 1.2,
  //         spaceBetween: 12
  //       },
  //       768: {
  //         slidesPerView: 2.1,
  //         spaceBetween: 16
  //       },
  //       990: {
  //         slidesPerView: 3.1,
  //         spaceBetween: 16
  //       },
  //       1200: {
  //         slidesPerView: 4.06,
  //         spaceBetween: 16
  //       }
  //     }
  //   });
  //   section.querySelectorAll(".formula-benefits-section__arrow--prev").forEach(function (button) {
  //     button.addEventListener("click", function () {
  //       swiper.slidePrev();
  //     });
  //   });
  //   section.querySelectorAll(".formula-benefits-section__arrow--next").forEach(function (button) {
  //     button.addEventListener("click", function () {
  //       swiper.slideNext();
  //     });
  //   });
  // });
  document.querySelectorAll(".formula-benefits-section").forEach(function (section) {
  var slider = section.querySelector(".formula-benefits-swiper");

  if (!slider || slider.swiper || typeof Swiper === "undefined") return;

  var prevButtons = section.querySelectorAll(
    ".formula-benefits-section__arrow--prev"
  );
  var nextButtons = section.querySelectorAll(
    ".formula-benefits-section__arrow--next"
  );

  var swiper = new Swiper(slider, {
    slidesPerView: 4,
    spaceBetween: 16,
    speed: 500,
    watchOverflow: true,

    pagination: {
      el: section.querySelector(
        ".formula-benefits-section__pagination"
      ),
      clickable: true
    },

    breakpoints: {
      0: {
        slidesPerView: 1.2,
        spaceBetween: 12
      },
      768: {
        slidesPerView: 2.1,
        spaceBetween: 16
      },
      990: {
        slidesPerView: 3.1,
        spaceBetween: 16
      },
      1200: {
        slidesPerView: 4.06,
        spaceBetween: 16
      }
    },

    on: {
      init: function () {
        updateArrowState(this);
      },
      slideChange: function () {
        updateArrowState(this);
      },
      resize: function () {
        updateArrowState(this);
      }
    }
  });

  function updateArrowState(swiper) {
    prevButtons.forEach(function (button) {
      button.classList.toggle("disabled", swiper.isBeginning);
    });

    nextButtons.forEach(function (button) {
      button.classList.toggle("disabled", swiper.isEnd);
    });
  }

  prevButtons.forEach(function (button) {
    button.addEventListener("click", function () {
      swiper.slidePrev();
    });
  });

  nextButtons.forEach(function (button) {
    button.addEventListener("click", function () {
      swiper.slideNext();
    });
  });
});

  // =========== End: Formula Benefits Slider ============= //

  // =========== Start: Performance Ingredients Slider ============= //

  function initPerformanceIngredientsSlider() {
    document.querySelectorAll('[data-ingredients-swiper]').forEach(function (slider) {
      if (slider.swiper) return;

      var section = slider.closest('.performance-ingredients');
      if (!section) return;

      var pagination = section.querySelector('[data-ingredients-pagination]');
      var prevButton = section.querySelector('[data-ingredients-prev]');
      var nextButton = section.querySelector('[data-ingredients-next]');

      new Swiper(slider, {
        slidesPerView: 2,
        spaceBetween: 16,
        speed: 500,
        watchOverflow: true,
        pagination: {
          el: pagination,
          clickable: true
        },
        navigation: {
          prevEl: prevButton,
          nextEl: nextButton
        },
        breakpoints: {
          0: {
            slidesPerView: 1.2,
            spaceBetween: 12
          },
          750: {
            slidesPerView: 2,
            spaceBetween: 16
          }
        }
      });
    });
  }
  initPerformanceIngredientsSlider();
  // =========== End: Performance Ingredients Slider ============= //


  // ============= Start: Ingredient Showcase Slider ============== //

  (function () {
    function initIngredientSwiper() {
      var section = document.querySelector('.lp-ingredient-showcase')
      if (!section || typeof Swiper === 'undefined') return;
      var slider = section.querySelector('.lp-ingredient-showcase__slider');
      if (!slider || slider.swiper) return;
      new Swiper(slider, {
        // slidesPerView: 1.171,
        slidesPerView: 1.21,
        spaceBetween: 16,
        speed: 400,
        grabCursor: true,
        navigation: {
          prevEl: section.querySelector('.lp-ingredient-showcase__prev'),
          nextEl: section.querySelector('.lp-ingredient-showcase__next')
        },
        pagination: {
          el: section.querySelector('.swiper-pagination'),
          clickable: true
        },
        breakpoints: {
          750: {
            slidesPerView: 2,
            spaceBetween: 16
          },

          990: {
            slidesPerView: 4,
            spaceBetween: 16
          }
        }
      });
    }

    function waitForSwiper() {
      if (typeof Swiper !== 'undefined') {
        initIngredientSwiper();
      } else {
        setTimeout(waitForSwiper, 50);
      }
    }

    waitForSwiper();

    document.addEventListener('shopify:section:load', function (event) {
      if (
        event.detail &&
        event.detail.sectionId === '{{ section.id }}'
      ) {
        setTimeout(initIngredientSwiper, 100);
      }
    });
  })();

  // ============= End: Ingredient Showcase Slider ============== //

  // ============= Start: Stciky Add to Cart ============== //
  function initStickyAddToCart() {
    const sticky = document.querySelector("[data-sticky-atc]");
    if (!sticky) return;
    const priceElement = sticky.querySelector("[data-sticky-price]");
    const currentPriceElement = sticky.querySelector("[data-sticky-current-price]");
    const comparePriceElement = sticky.querySelector("[data-sticky-compare-price]");
    const submitButton = sticky.querySelector("[data-sticky-submit]");
    const formId = sticky.dataset.productFormId;
    if (!priceElement || !submitButton || !formId) return;
    const productForm = document.getElementById(formId);
    if (!productForm) return;
    const getSelectedPrice = () => {
      const oneTimePlan = document.querySelector("#single-purchase-plan");
      if (
        oneTimePlan?.classList.contains(
          "wt-subscription-widget__plans--selected"
        )
      ) {
        const buyOnceTotal = oneTimePlan.querySelector(
          "[data-buyonce-total]"
        );

        if (buyOnceTotal) {
          const buyOnceRows = oneTimePlan.querySelectorAll(
            "[data-buyonce-panel] .wt-subscription-widget__buyonce-row"
          );

          let total = 0;
          let hasQuantity = false;

          buyOnceRows.forEach((row) => {
            const input = row.querySelector("[data-buyonce-input]");
            const quantity = Math.max(
              0,
              parseInt(input?.value || "0", 10) || 0
            );
            const price = Number(row.dataset.price || 0);

            if (quantity > 0) {
              hasQuantity = true;
              total += price * quantity;
            }
          });
          if (!hasQuantity) {
            const firstAvailableRow = Array.from(buyOnceRows).find(
              (row) => !row.classList.contains("is-unavailable")
            );

            if (firstAvailableRow) {
              total = Number(firstAvailableRow.dataset.price || 0);
            }
          }
          return {
            priceRaw: String(total),
            price: buyOnceTotal.textContent.trim(),
            priceFormatted: buyOnceTotal.textContent.trim(),
            compareAtPriceRaw: "0",
            compareAtPrice: "",
            compareAtPriceFormatted: ""
          };
        }
      }
      const selectedPlan = document.querySelector(
        ".wt-subscription-widget__plans--selected .wt-subscription-widget__plan-content__select"
      );

      if (selectedPlan) {
        const option = selectedPlan.options[selectedPlan.selectedIndex];

        if (option) {
          return option.dataset;
        }
      }
      const selectedOptionCard = document.querySelector(
        ".wt-subscription-widget__option-card--selected"
      );
      if (selectedOptionCard) {
        return selectedOptionCard.dataset;
      }
      return null;
    };
    const updateStickyPrice = () => {
      const selectedPrice = getSelectedPrice();
      if (!selectedPrice) return;
      const price = selectedPrice.priceFormatted || selectedPrice.price || "";
      const comparePrice = selectedPrice.compareAtPriceFormatted || selectedPrice.compareAtPrice || "";
      if (currentPriceElement && price && currentPriceElement.textContent !== price) {
        currentPriceElement.textContent = price;
      } else if (!currentPriceElement && price && priceElement.textContent !== price) {
        priceElement.textContent = price;
      }
      if (comparePriceElement) {
        const priceRaw = Number(selectedPrice.priceRaw);
        const compareAtPriceRaw = Number(selectedPrice.compareAtPriceRaw);
        const hasComparePrice = comparePrice && compareAtPriceRaw > priceRaw;
        comparePriceElement.hidden = !hasComparePrice;
        if (hasComparePrice && comparePriceElement.textContent !== comparePrice) {
          comparePriceElement.textContent = comparePrice;
        }
      }
    };
    const updateStickyAvailability = () => {
      const mainButton = productForm.querySelector('button[name="add"]');
      if (mainButton) {
        submitButton.disabled = mainButton.disabled;
      }
    };
    const updateSticky = () => {
      updateStickyPrice();
      updateStickyAvailability();
    };
    submitButton.addEventListener("click", function (event) {
      event.preventDefault();
      const featuredProduct = document.querySelector("#featured-product");
      if (!featuredProduct) return;
      featuredProduct.scrollIntoView({
        behavior: "smooth",
        block: "start"
      });
    });
    document.addEventListener("click", function (event) {
      if (
        event.target.closest(
          ".wt-subscription-widget__option-card, .wt-subscription-widget__plans"
        )
      ) {
        setTimeout(updateSticky, 150);
      }
    });
    productForm.addEventListener("change", function () {
      setTimeout(updateSticky, 150);
    });
    const observer = new MutationObserver(updateSticky);
    observer.observe(productForm, {
      subtree: true,
      childList: true,
      attributes: true,
      attributeFilter: ["class", "disabled", "data-price", "data-price-formatted"]
    });
    let ticking = false;
    const checkStickyVisibility = () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(() => {
        const rect = productForm.getBoundingClientRect();
        const isVisible = rect.top < window.innerHeight && rect.bottom > 0;
        sticky.classList.toggle("is-visible", !isVisible);
        document.body.classList.toggle("sticky-atc-visible", !isVisible);
        ticking = false;
      });
    };
    updateSticky();
    checkStickyVisibility();
    window.addEventListener("scroll", checkStickyVisibility, { passive: true });
    window.addEventListener("resize", checkStickyVisibility);
  }
  initStickyAddToCart();
  // ============= End: Stciky Add to Cart ============== //


  // ============= Start: LP Benefits Grid Slider ============== //
  (function () {
    function shouldUseGrid(section) {
      return (
        window.matchMedia('(min-width: 990px)').matches &&
        section.dataset.layout === 'static_grid'
      );
    }

    function syncBenefitsGridSlider(slider) {
      var section = slider.closest('.lp-benefits-grid-section');
      if (!section || typeof Swiper === 'undefined') return;

      if (shouldUseGrid(section)) {
        if (slider.swiper) {
          slider.swiper.destroy(true, true);
        }
        return;
      }

      if (slider.swiper) return;

      var slideCount = slider.querySelectorAll('.swiper-slide').length;

      new Swiper(slider, {
        slidesPerView: 1.26,
        slidesPerGroup: 2,
        spaceBetween: 16,
        speed: 400,
        grabCursor: true,
        loop: false,
        slidesOffsetBefore: 16,
        slidesOffsetAfter: 16,
        navigation: {
          prevEl: section.querySelector('.lp-benefits-grid__prev'),
          nextEl: section.querySelector('.lp-benefits-grid__next'),
        },
        pagination:
          slideCount > 1
            ? {
                el: section.querySelector('.lp-benefits-grid__pagination'),
                clickable: true,
              }
            : false,
        breakpoints: {
          544: {
            slidesPerView: 2.2,
            spaceBetween: 16,
          },
        },
      });
    }

    function initAllBenefitsGridSliders() {
      document
        .querySelectorAll('[data-benefits-grid-slider]')
        .forEach(syncBenefitsGridSlider);
    }

    function waitForSwiper() {
      if (typeof Swiper !== 'undefined') {
        initAllBenefitsGridSliders();
      } else {
        setTimeout(waitForSwiper, 50);
      }
    }

    waitForSwiper();

    var benefitsGridResizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(benefitsGridResizeTimer);
      benefitsGridResizeTimer = setTimeout(initAllBenefitsGridSliders, 150);
    });

    document.addEventListener('shopify:section:load', function () {
      setTimeout(initAllBenefitsGridSliders, 100);
    });
  })();
  // ============= End: LP Benefits Grid Slider ============== //

  // ============= Start: Stop LP Featured Product Review Card Slider ============== //

  const featuredReviews = document.querySelectorAll("[data-featured-reviews]");
  featuredReviews.forEach(function (reviewsWrapper) {
    const slider = reviewsWrapper.querySelector("[data-featured-reviews-slider]");
    if (!slider || slider.swiper) return;
    const reviewCount = parseInt(
      reviewsWrapper.getAttribute("data-review-count"),
      10
    );
    if (reviewCount <= 1) return;
    const pagination = reviewsWrapper.querySelector(
      ".featured-reviews__pagination"
    );
    const prevButton = reviewsWrapper.querySelector(
      ".featured-reviews__arrow--prev"
    );
    const nextButton = reviewsWrapper.querySelector(
      ".featured-reviews__arrow--next"
    );
    new Swiper(slider, {
      slidesPerView: 1,
      spaceBetween: 20,
      speed: 600,
      loop: reviewCount > 1,
      watchOverflow: true,
      pagination: {
        el: pagination,
        clickable: true
      },
      navigation: {
        prevEl: prevButton,
        nextEl: nextButton
      }
    });
  });
  // ============= End: Stop LP Featured Product Review Card Slider ============== //

  initPerformanceReviewSlider();
  initBenefitsSlider();
});
